import { render, staticRenderFns } from "./login-pasw.vue?vue&type=template&id=42003c84&scoped=true&"
import script from "./login-pasw.vue?vue&type=script&lang=js&"
export * from "./login-pasw.vue?vue&type=script&lang=js&"
import style0 from "./login-pasw.vue?vue&type=style&index=0&id=42003c84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42003c84",
  null
  
)

export default component.exports